interface LabelProps {
    text: string;
    htmlFor?: string;
    className?: string;
    required?: boolean;
    onClick?: () => void;
    isDisabled?: boolean;
    color?: string;
    size?: "sm" | "md" | "lg";
    children?: React.ReactNode;
}

const Label = ({
    text,
    htmlFor,
    className,
    required,
    onClick,
    isDisabled,
    color,
    size = "md",
    children,
}: LabelProps) => {
    const sizeStyles = {
        sm: "text-[10px] 2xl:text-xs",
        md: "text-xs 2xl:text-sm",
        lg: "text-sm 2xl:text-base",
    };
    return (
        <label
            htmlFor={htmlFor}
            className={`block ${sizeStyles[size]} font-medium ${isDisabled ? "text-gray-200" : color || "text-gray-700"
                } ${className}`}
            onClick={onClick}
        >
            {text} {required && <span className="text-red-500">*</span>} {children}
        </label>
    );
};

export { Label };

